import * as React from "react";

interface SpecificationSectionProps {
  text: string;
}

const SpecificationSection = ({ text }: SpecificationSectionProps) => {
  return (
    <div className="dimension-detail">
      <span className=" title">Specification:</span>
      <span className="res-title content-detail">{text}</span>
    </div>
  );
};

export default SpecificationSection;
